<template>
  <div class="row">
    <div class="mx-auto col-md-12">
      <div class="card p-3 mb-3">
        <div class="card-body">
          <beneficiarioHeader
            :cpf_requerente="familia.cpf_requerente"
            :nome_completo="familia.nome_completo"
            :situacao="familia.ind_ativo"
          >
          </beneficiarioHeader>
          <b-card class="mb-2" header="Pagamentos" header-tag="header">
            <b-card no-body class="mb-3">
              <b-card-header
                header-bg-variant="outline-secondary"
                header-tag="header"
                class="p-0"
                role="tab"
              >
                <span class="mb-1 p-1" align="left">
                  <strong> AUXÍLIO PECUNIÁRIO ESTAMOS JUNTOS</strong>
                </span>
              </b-card-header>
              <b-row>
                <b-col>
                    <b-table
                      small
                      class="table-overflow"
                      show-empty
                      bordered
                      :sticky-header="true"
                      :no-border-collapse="false"
                      responsive
                      :fields="tabela.fields"
                      :items="tabela.beneficio_ej"
                    >
                      <template v-slot:empty>
                        Nenhum registro encontrado
                      </template>
                      <template v-slot:cell(data_aceite_beneficio)="data">
                        {{ $helpers.formatDateHourToDate(data.value) }}
                      </template>
                    </b-table>

                </b-col>
              </b-row>
            </b-card>
            <template v-slot:footer>
              <b-row>
                <b-col class="text-left">
                  <b-button
                    variant="outline-secondary"
                    @click.prevent="voltar"
                    title="Voltar"
                  >
                    <font-awesome-icon
                      :icon="['fas', 'arrow-left']"
                      title="Voltar"
                      class="mr-1"
                    />
                    Voltar
                  </b-button>
                </b-col>
              </b-row>
            </template>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Familia from "../../../models/Familia";
import beneficiarioHeader from "../../../components/BeneficiarioHeader";

export default {
  components: {
    beneficiarioHeader,
  },

  data() {
    return {
      possuiBeneficios: false,
      familia: new Familia(),
      tabela: {
        beneficio_ej: [],
        fields: [
          {
            key: "data_aceite_beneficio",
            label: "Data Aceite Benefício",
            class: "text-center",
          },
          {
            key: "mes_referencia",
            label: "Mês Referência",
            class: "text-center",
          },
          {
            key: "ano_referencia",
            label: "Ano Referência",
            class: "text-center",
          },
          {
            key: "descricao_status_pagamento",
            label: "Status Pagamento",
            class: "text-center",
          },
        ],
      },
      exibir_beneficio_ej: true,
    };
  },

  computed: {},

  methods: {
    obterPagamentos() {
      return this.$api
        .get(`pagamentos/${this.$route.params.id}`)
        .then((response) => {
          if (response.data.dados.length > 0) {
            this.exibir_beneficio_ej = true;
            response.data.dados.forEach((element) => {
              this.tabela.beneficio_ej.push(element);
            });
          } else {
            this.exibir_beneficio_ej = false;
          }
        })
        .catch((error) => {
          this.$helpers.showToast(
            this,
            "Erro",
            error.response.data.message,
            "danger"
          );
        });
    },

    voltar() {
      this.$router.push({ name: "beneficiarios" });
    },
  },

  mounted() {
    this.obterPagamentos();
    this.familia = this.$route.params.beneficiario;
  },
};
</script>

<style scoped>
.table-overflow {
  overflow-y: hidden;
  max-height: 100%;
}
</style>
